import { consoleLogger } from '@shared/logging/consoleLogger';

export const getVersions = (versionString: string) => {
  const lastIndex =
    versionString.lastIndexOf('.') !== -1
      ? versionString.lastIndexOf('.')
      : versionString.length;
  const majorVersion =
    Number(
      versionString.substring(versionString.indexOf('v') + 1, lastIndex),
    ) || null;
  const minorVersion = Number(versionString.split('.')[1]) || null;

  if (majorVersion === null) {
    consoleLogger.logDebug(
      'Major version cannot be read from version string:',
      versionString,
    );
  }
  if (minorVersion === null) {
    consoleLogger.logDebug(
      'Minor version cannot be read from version string:',
      versionString,
    );
  }

  return {
    majorVersion,
    minorVersion,
  };
};
